export default "__VITE_ASSET__CgkkXWlV__"